module.exports = __webpack_public_path__ + "static/media/foto11.067d72ac.jpg";